import { create } from "zustand";

interface RevenueMachineState {
  storeId: any;
  startDate: any;
  endDate: any;
  revenueMachine: any;
  setRevenueMachine: (revenueStore: any) => void;
  setStoreId: (accountId: any) => void;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
}

export const useRevenueMachine = create<RevenueMachineState>((set) => ({
  storeId: undefined,
  startDate: undefined,
  endDate: undefined,
  revenueMachine: null,
  setRevenueMachine: (revenueMachine) => set({ revenueMachine }),
  setStoreId: (storeId) => set({ storeId }),
  setStartDate: (startDate) => set({ startDate }),
  setEndDate: (endDate) => set({ endDate }),
}));
